import { AdministratorModel, type IAdministratorModel } from "models/user/administrator/entities/AdministratorModel";

export interface ISeparatorModel extends IAdministratorModel{
    qrCode?: string;
}

export class SeparatorModel extends AdministratorModel{
    qrCode?: string;

    constructor(data: ISeparatorModel) {
        super(data);
        this.qrCode = data.qrCode;
    }
}